import { render, staticRenderFns } from "./pedidosActivos.vue?vue&type=template&id=bdf85a7c&scoped=true&"
import script from "./pedidosActivos.vue?vue&type=script&lang=js&"
export * from "./pedidosActivos.vue?vue&type=script&lang=js&"
import style0 from "./pedidosActivos.vue?vue&type=style&index=0&id=bdf85a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf85a7c",
  null
  
)

export default component.exports